export const initOneTrustScript = (token: string): void => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js')
  script.setAttribute('charset', 'UTF-8')
  script.setAttribute('data-domain-script', token)
  document.getElementsByTagName('head')[0].appendChild(script)
}
